import React from 'react';
import {
  Row,
  Col,
  Label,
  Input,
  FormGroup
} from 'reactstrap';
import { ProductConfiguratorFormData } from '../ProductConfiguratorModal';

interface AuditProfileSectionProps {
  formData: ProductConfiguratorFormData;
}

const AuditProfileSection: React.FC<AuditProfileSectionProps> = ({ formData }) => {
  return (
    <fieldset className="border rounded p-2">
      <legend className="float-none w-auto px-2 mb-0 text-body" style={{ fontSize: '0.9rem' }}>Audit Profile</legend>

      <Row className="g-0">
        {/* Created */}
        <Col md={12}>
          <FormGroup>
            <Label className="form-label mb-1">Created</Label>
            <Input
              type="text"
              bsSize="sm"
              value={formData.created || '18/02/2021 02:14:34 PM'}
              readOnly
              className="bg-light"
            />
          </FormGroup>
        </Col>

        {/* Created By */}
        <Col md={12}>
          <FormGroup>
            <Label className="form-label mb-1">Created By</Label>
            <Input
              type="text"
              bsSize="sm"
              value={formData.createdBy || 'Power User'}
              readOnly
              className="bg-light"
            />
          </FormGroup>
        </Col>

        {/* Last Updated */}
        <Col md={12}>
          <FormGroup>
            <Label className="form-label mb-1">Last Updated</Label>
            <Input
              type="text"
              bsSize="sm"
              value={formData.lastUpdated || '02/03/2021 10:22:19 PM'}
              readOnly
              className="bg-light"
            />
          </FormGroup>
        </Col>

        {/* Last Updated By */}
        <Col md={12}>
          <FormGroup>
            <Label className="form-label mb-1">Last Updated By</Label>
            <Input
              type="text"
              bsSize="sm"
              value={formData.lastUpdatedBy || 'Web Sale'}
              readOnly
              className="bg-light"
            />
          </FormGroup>
        </Col>

        {/* Location Owner */}
        <Col md={12}>
          <FormGroup>
            <Label className="form-label mb-1">Location Owner</Label>
            <div className="d-flex">
              <Input
                type="text"
                bsSize="sm"
                value={formData.locationOwner}
                readOnly
                className="bg-light"
              />
              <button 
                type="button" 
                className="btn btn-outline-secondary btn-sm ms-1"
                style={{ minWidth: '32px' }}
              >
                <i className="ri-search-line"></i>
              </button>
            </div>
          </FormGroup>
        </Col>
      </Row>
    </fieldset>
  );
};

export default AuditProfileSection;
